import React from 'react'
// context
import { ResourcesListAPIContext } from 'containers/Activities/layers/API/ResourcesList'
import { ResourcesListBLContext } from 'containers/Activities/layers/BL/ResourcesList'
// types
import { IPlanObjectiveResource } from 'types/graphql'
// components
import { Menu } from 'components/UI'
// icons
import EditIcon from '@mui/icons-material/EditOutlined'
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined'
// views
import { DotsIcon } from './views'

interface Props {
  resource: IPlanObjectiveResource
}

const ResourceActionsMenu: React.FC<Props> = ({ resource }) => {
  const { canModify, canDelete } = React.useContext(ResourcesListAPIContext)
  const { handleEditResource, handleDeleteResource } = React.useContext(ResourcesListBLContext)

  const deleteResource = () => {
    handleDeleteResource(resource)
  }

  const editResource = () => {
    handleEditResource(resource)
  }

  return (
    <Menu trigger={<DotsIcon htmlColor='black' />}>
      {canModify && (
        <span onClick={editResource}>
          <EditIcon />
          Edit
        </span>
      )}
      {canDelete && (
        <span onClick={deleteResource}>
          <DeleteIcon />
          Delete
        </span>
      )}
    </Menu>
  )
}

export default ResourceActionsMenu
